import { exitFullscreen } from "@fxid/shared";
import { openContextModal } from "@mantine/modals";

export const openTextCopyModal = (params: { text: string } & { onClose?: () => void }) => {
	const { onClose, ...innerProps } = params;

	void exitFullscreen();

	openContextModal({
		modal: "textCopyModal",
		innerProps: { text: params.text },
		withCloseButton: true,
		size: "lg"
		// styles: {
		// 	body: {
		// 		padding: "20px"
		// 	}
		// }
	});
};
